<template>
    <el-form label-width="180px" :inline="true" :model="form" class="demo-form-inline">
        <el-form-item label="名称" required>
            <el-input v-model="form.title" />
        </el-form-item>
        <!-- <h4 class="form-title">升级条件</h4> -->
        <el-form-item label="邀请人数" required>
            <el-input v-model="form.team_user" />
        </el-form-item>
        <!-- <h4 class="form-title">会员权益</h4> -->
        <el-form-item label="作业金额" required>
            <el-input v-model="form.invest" />
        </el-form-item>
        <el-form-item label="直聘返利" required>
            <el-input v-model="form.rabate_v1" />
        </el-form-item>
        <el-form-item label="间聘返利" required>
            <el-input v-model="form.rabate_v2" />
        </el-form-item>
        <el-form-item label="收益率" required>
            <el-input v-model="form.invest_rate" />
        </el-form-item>
        <!-- <el-form-item label="额外收益" required>
            <el-input v-model="form.extra" />
        </el-form-item> -->
        <el-form-item label="升级充值" required>
            <el-input v-model="form.recharge" />
        </el-form-item>
        <el-form-item label="提款手续费(%)" required>
            <el-input v-model="form.handling_fee" />
        </el-form-item>
        <el-form-item label="这等级可购买产品额度" required>
            <el-input v-model="form.investment" />
        </el-form-item>
    </el-form>
</template>

<script setup>
import { nextTick, onMounted, ref } from 'vue'
import { withdrawTypeEnums, getLabelByVal } from '@/config/enums'

const form = ref({
    title: "",
    // extra: "",
    invest: "",
    team_user: "",
    recharge: "",
    handling_fee: "",
    investment: "",
    rabate_v1: "",
    rabate_v2: "",
    invest_rate: "",
})
const props = defineProps(['item'])

onMounted(() => {
    nextTick(() => {
        form.value = Object.assign(form, props.item)
    })
})

defineExpose({ form })

</script>

<style lang="less" scoped>
.demo-form-inline {
    justify-content: flex-start;
    display: flex;
    flex-wrap: wrap;
}

.demo-form-inline .el-input {
    --el-input-width: 220px;
}

.demo-form-inline .el-select {
    --el-select-width: 220px;
}

/deep/ .el-radio-group {
    width: 220px;
}

.form-title {
    text-align: left;
    padding-left: 30px;
    margin: 20px auto 10px;
    height: 44px;
    background-color: #f2f2f2;
    border-radius: 5px;
    line-height: 44px;
    width: 100%;
}

/deep/ .el-form-item {
    align-items: flex-start;
}
</style>